import PostsSerializer from './base';

export default class Tag extends PostsSerializer {}
